import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import { Dates } from '../../rrhh/rrhh-team-members-form/rrhh-team-members-form.component';

@Component({
  selector: 'app-rrhh-change-date-agent',
  templateUrl: './rrhh-change-date-agent.component.html',
  styleUrls: ['./rrhh-change-date-agent.component.scss'],
})
export class RrhhChangeDateAgentComponent implements OnInit {
  @Input() value!: Dates;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  
  datePickerFrom: QRDatePicker = {
    isDisplayedUp: false, 
    calendarWidth: 180, 
    minDate: '',
    maxDate: '',
    date: undefined, 
    errorMsg: ''
  };
  
  dialogEvent: DialogEvent = {
      isButtonActionDisabled: false,
      value: { dateFrom: undefined, dateTo: undefined },
  };

  fullName: string = '';

  constructor() { }

  ngOnInit(): void {
    this.datePickerFrom.minDate = this.value.dateFrom;
    this.datePickerFrom.maxDate = this.value.dateTo;
    this.datePickerFrom.date = this.value.startDate;
    this.fullName = this.value.fullName;
    this.dialogEvent.value = {
      dateFrom: this.value.dateFrom,
      dateTo: this.value.dateTo
    }
  }

  datepickerFromChange(e: string): void {
    this.dialogEvent = {
      ...this.dialogEvent,
      value: {
        ...this.dialogEvent.value,
        dateFrom: e,
      },
    };
    this.datePickerFrom.date = e;
    this.change.emit(e)
  }
}

